import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { ButtonColor, CommonActionKey } from '../base-dialog/base-dialog.model';
import { SimpleDialogComponent } from './simple-dialog.component';
import { SimpleDialogData } from './simple-dialog.model';

@Injectable({ providedIn: 'root' })
export class SimpleDialogService {
	constructor(private readonly dialog: MatDialog) { }

	openSimpleDialog(inputData: SimpleDialogData): Observable<string> {
		return SimpleDialogComponent.show(this.dialog, inputData)
	}

	openSimpleConfirmDialog(body: string | SafeHtml, title?: string, width?: string): Observable<string> {
		const dialogData: SimpleDialogData = {
			title,
			body,
			actions: [
				{ label: "CANCEL", buttonColor: ButtonColor.Default, actionKey: CommonActionKey.Cancel },
				{ label: "CONFIRM", buttonColor: ButtonColor.Primary, actionKey: CommonActionKey.Confirm }
			],
			config: {
				width
			}
		};

		return this.openSimpleDialog(dialogData);
	}
}